"use strict";

class SpaDatesImportController {

    constructor($timeout,
                $window,
                Upload,
                SSHttpService,
                SSAlertService,
                SSUtilService,
                SSUserService,
                OTPService) {
        const self = this;

        self.$timeout = $timeout;
        self.$window = $window;
        self.Upload = Upload;
        self.SSHttpService = SSHttpService;
        self.SSAlertService = SSAlertService;
        self.SSUtilService = SSUtilService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;

        self.data = SHOWSUITE.data;
        self.PROPERTY_STATUS_APPROVED = SHOWSUITE.PROPERTY_STATUS_APPROVED;
        self.PROPERTY_STATUS_LISTED = SHOWSUITE.PROPERTY_STATUS_LISTED;
        self.PROPERTY_STATUS_ARCHIVED = SHOWSUITE.PROPERTY_STATUS_ARCHIVED;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()
            && self.SSUserService.hasPermissionForAnyProperty('DMS_SPA_PYMTS')) {
            self.has_access = true;
            self.init();
        }
    }

    init() {
        const self = this;

        self.properties = [];
        self.property_id = '';
        self.importFile = null;
        self.useSpaExpiryDate = false;
        self.revertDates = false;
        self.results = null;
        self.progressUploadingFiles = false;
        self.filesUploadProgress = 0;

        self.getDeveloperProperties();
    }

    getDeveloperProperties() {
        const self = this;

        loading(true);
        self.SSHttpService.getAPIRequest('sec/developer/properties/list').then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let _properties = response.data.properties || [];
            $.each(_properties, function (i, property) {
                if (property.status === self.PROPERTY_STATUS_APPROVED
                    || property.status === self.PROPERTY_STATUS_LISTED) {
                    self.properties.push(property);
                }
            });

            self.$timeout(function () {
                jQuery('#property-select').niceSelect('update');
            });
        });
    }

    validateImportParams() {
        const self = this;

        if (!self.property_id) return false;
        if (!self.importFile) return false;
        return true;
    }

    onRevertDatesChange() {
        const self = this;

        // In revert mode the backend always honours the file's SPA Expiry Date
        // column, so the use_spa_expiry_date toggle is implied — reflect that in
        // the UI by locking it on (the checkbox is also ng-disabled while revert).
        if (self.revertDates) {
            self.useSpaExpiryDate = true;
        }
    }

    importSpaDates() {
        const self = this;

        if (!self.validateImportParams()) return;

        if (self.revertDates && !self.$window.confirm(
            'REVERT DATES is enabled.\n\n'
            + 'This will overwrite the SPA dates of the matching sales directly from the file '
            + '(including blank cells) and reset each sale\'s status. It permanently changes live '
            + 'sale data and cannot be undone here.\n\n'
            + 'Only continue if you are performing a migration rollback and understand the effect.\n\n'
            + 'Proceed?'
        )) {
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function () {
                self.uploadSpaDatesFile(self.importFile);
            }
        );
    }

    uploadSpaDatesFile(file) {
        const self = this;

        self.progressUploadingFiles = true;
        self.filesUploadProgress = 0;

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/developer/sales/import-spa-dates'),
            method: 'POST',
            data: {
                property_id: self.property_id,
                import_file: file,
                use_spa_expiry_date: !!self.useSpaExpiryDate,
                revert_dates: !!self.revertDates
            },
            withCredentials: true
        }).then(
            function (response) {
                loading(false);
                self.progressUploadingFiles = false;

                let payload = (response && response.data) ? response.data : {};

                if (payload.code && payload.code !== 200) {
                    self.SSAlertService.parseAndDisplayError(payload);
                    return;
                }

                let data = payload.data || payload;
                let errors = data.errors || [];
                let successCount = data.success_count != null
                    ? data.success_count
                    : Math.max(0, (data.total || 0) - errors.length);
                let total = data.total != null ? data.total : (successCount + errors.length);

                self.results = {
                    total: total,
                    success_count: successCount,
                    error_count: errors.length,
                    errors: errors
                };
            },
            function (response) {
                self.progressUploadingFiles = false;
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
            },
            function (evt) {
                if (evt && evt.lengthComputable) {
                    self.filesUploadProgress = parseInt(100.0 * evt.loaded / evt.total);
                }
            }
        );
    }

    reset() {
        const self = this;

        self.results = null;
        self.importFile = null;
        self.filesUploadProgress = 0;
    }

    goBack() {
        const self = this;

        self.$window.location.href = '/developer/sales/spa-dates';
    }
}

SpaDatesImportController.$inject = [
    '$timeout',
    '$window',
    'Upload',
    'SSHttpService',
    'SSAlertService',
    'SSUtilService',
    'SSUserService',
    'OTPService'
];
app.controller('SpaDatesImportController', SpaDatesImportController);
